import { filterClasses } from "@swivl-mono/helpers";
import React from "react";
import { RiDeleteBinLine } from "react-icons/ri";

interface SelectedCustomerCardProps {
  name: string;
  subtitle?: string | null;
  onRemove: () => void;
  variant?: "default" | "mobile";
}

export function SelectedCustomerCard({ name, subtitle, onRemove, variant = "default" }: SelectedCustomerCardProps): React.ReactNode {
  const isMobile = variant === "mobile";

  return (
    <button
      type="button"
      onClick={onRemove}
      className={filterClasses(
        "group flex w-full cursor-pointer items-center gap-2 rounded border px-3 py-2 text-left",
        isMobile ? "border-orange-500 bg-orange-50" : "border-grey-400 bg-white hover:bg-grey-50"
      )}
    >
      <div className="min-w-0 flex-1">
        <p className={isMobile ? "body-sm-alt text-black" : "body-sm-alt text-black"}>{name}</p>
        {!isMobile && subtitle && <p className="body-sm text-grey-600">{subtitle}</p>}
      </div>
      <RiDeleteBinLine className={filterClasses("size-[18px] shrink-0", isMobile ? "text-black" : "text-grey-600 group-hover:text-orange-500")} />
    </button>
  );
}
